import React, { KeyboardEvent } from 'react';
import _uniqueId from 'lodash/uniqueId';
import { InputSize } from '../models/InputSize';
import { Label } from '../Label/index';
import './styles.scss';
import { InputPropsBase } from '../interfaces/Inputs';
import TsrSvgIcon from '../../assets/icons';
import TsrTooltip from '../../tooltip';
import { InputContainer } from '../InputContainer';
import { Alignment } from '../../layout';

interface ToogleSwitchProps extends InputPropsBase<boolean, boolean> {}

export default function ToogleSwitch(props: ToogleSwitchProps) {
    const id = _uniqueId('idToogleSwitch-');
    const onBlur = () => {
        props.onBlur && props.onBlur(props.value);
    };
    function handleKeyPress(e: KeyboardEvent) {
        if (e.key !== ' ') {
            return;
        }
        e.preventDefault();
        props.onChange && props.onChange(!props.value);
    }
    return (
        <InputContainer
            className={'switchContainer' + (props.className ? ' ' + props.className : '')}
            gap={props.gap}
            justify={props.justify}
            align={props.align || Alignment.flexStart}
            width={props.width}
            height={props.height}
            overflow={props.overflow}
            inputContainerLength={props.inputContainerLength}
        >
            <Label
                id={props.id || id}
                content={props.label}
                disabled={props.disabled === true}
                labelPosition={props.labelPosition}
                className={props.labelClassName}
            >
                <div
                    className={
                        'toggle-switch' +
                        (props.size === InputSize.Small || !props.size ? ' small-switch' : '') +
                        (props.size === InputSize.Medium ? ' medium-switch' : '') +
                        (props.size === InputSize.Large ? ' large-switch' : '')
                    }
                >
                    <input
                        type="checkbox"
                        name={props.name}
                        className="toggle-switch-checkbox"
                        id={props.id || id}
                        checked={props.value}
                        disabled={props.disabled === 'inputOnly' || props.disabled === true}
                        tabIndex={-1}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange && props.onChange(e.target.checked)}
                        onBlur={onBlur}
                    />
                    {props.id || id ? (
                        <label
                            className="toggle-switch-label"
                            htmlFor={props.id || id}
                            tabIndex={props.disabled === 'inputOnly' || props.disabled === true ? -1 : 0}
                            onKeyDown={(e: React.KeyboardEvent<HTMLLabelElement>) => {
                                handleKeyPress(e);
                            }}
                        >
                            <span
                                className={
                                    props.disabled === 'inputOnly' || props.disabled === true
                                        ? 'toggle-switch-inner toggle-switch-disabled'
                                        : 'toggle-switch-inner'
                                }
                                tabIndex={-1}
                            />
                            <span
                                className={
                                    props.disabled === 'inputOnly' || props.disabled === true
                                        ? 'toggle-switch-switch toggle-switch-disabled'
                                        : 'toggle-switch-switch'
                                }
                                tabIndex={-1}
                            />
                        </label>
                    ) : (
                        <></>
                    )}
                </div>
                {props.errorMessage && !props.disabled ? (
                    <TsrTooltip icon={true} content={props.errorMessage}>
                        <TsrSvgIcon icon="information" color="error" pointer />
                    </TsrTooltip>
                ) : props.infoMessage && !props.disabled ? (
                    <TsrTooltip icon={true} content={props.infoMessage}>
                        <TsrSvgIcon icon="information" color="info" pointer />
                    </TsrTooltip>
                ) : (
                    props.infoMessage && <TsrSvgIcon icon="information" color="disabled" />
                )}
            </Label>
        </InputContainer>
    );
}
